import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { IconButton } from '@mui/material';
import { CloseIcon } from 'src/theme/overrides/CustomIcons';

export function Modal(props) {
  const {
    open,
    onConfirm,
    close,
    title,
    content,
    confirmButtonText = 'Confirmar',
    cancelButtonText = 'Cancelar',
    disabled,
    afterConfirm,
    showConfirmButton = true,
    showCancelButton = true,
    cancelButtonPosition = 'bottom',
    maxWidth = 'sm',
    fullWidth = true,
    isConfirming = false,
  } = props;

  const handleConfirmButton = React.useCallback(() => {
    onConfirm();

    if (afterConfirm) {
      afterConfirm();
    }
  }, [onConfirm, afterConfirm]);

  const showModalActions =
    (showCancelButton && cancelButtonPosition === 'bottom') ||
    showConfirmButton;

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={(theme) => ({
          pb: theme.spacing(3),
        })}
      >
        {title}
        {showCancelButton && cancelButtonPosition === 'top' ? (
          <IconButton
            aria-label="close"
            onClick={close}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        {typeof content === 'string' ? (
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        ) : (
          content
        )}
      </DialogContent>
      {showModalActions && (
        <DialogActions>
          {showCancelButton && cancelButtonPosition === 'bottom' && (
            <Button variant="contained" color="error" onClick={close}>
              {cancelButtonText}
            </Button>
          )}
          {showConfirmButton &&
            (isConfirming ? (
              <LoadingButton variant="contained" loading>
                {confirmButtonText}
              </LoadingButton>
            ) : (
              <Button
                variant="contained"
                onClick={handleConfirmButton}
                disabled={disabled}
                autoFocus
              >
                {confirmButtonText}
              </Button>
            ))}
        </DialogActions>
      )}
    </Dialog>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.array,
  ]),
  afterConfirm: PropTypes.func,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  disabled: PropTypes.bool,
  isConfirming: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  cancelButtonPosition: PropTypes.oneOf(['top', 'bottom']),
};

export default Modal;
